import { render } from "./BaseInput.vue?vue&type=template&id=2ab1d08e&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=2ab1d08e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab1d08e"]])

export default __exports__